"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import { SectionHeader, StatsGrid } from "fansunited-sports-ui";
import { usePlayerPageData } from "../context/PlayerPageDataContext";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { getPositionGroup } from "@/utilities/mappers/squad";
export const PlayerSeasonHighlights: React.FC = () => {
  const $ = _c(23);
  const {
    player,
    activeSeasonStats
  } = usePlayerPageData();
  const labels = useLabels().playerPage.seasonStats;
  let t0;
  bb0: {
    if (activeSeasonStats.length === 0) {
      t0 = null;
      break bb0;
    }
    let t1;
    if ($[0] !== activeSeasonStats) {
      t1 = activeSeasonStats.reduce(_temp, {
        appearances: 0,
        minutes: 0,
        goals: 0,
        assists: 0,
        cleansheets: 0,
        saves: 0,
        conceded: 0,
        shots: 0,
        shotsOnTarget: 0
      });
      $[0] = activeSeasonStats;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    t0 = t1;
  }
  const aggregated = t0;
  if (!aggregated) {
    return null;
  }
  let t1;
  if ($[2] !== aggregated || $[3] !== labels || $[4] !== player.position) {
    const positionGroup = getPositionGroup(player.position);
    t1 = getHighlightStats(positionGroup, aggregated, labels);
    $[2] = aggregated;
    $[3] = labels;
    $[4] = player.position;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const statsData = t1;
  const colsDesktop = statsData.length as 4 | 5;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      typography: {
        name: "text-sm uppercase font-semibold text-foreground"
      }
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== labels.title) {
    t3 = {
      name: labels.title,
      styles: t2
    };
    $[7] = labels.title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      container: "mb-2"
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3) {
    t5 = <SectionHeader entity={t3} styles={t4} />;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== colsDesktop) {
    t6 = {
      colsDesktop,
      colsMobile: 2
    };
    $[12] = colsDesktop;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      container: "bg-card shadow-md py-3.5"
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6) {
    t8 = {
      grid: t6,
      item: t7
    };
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== statsData || $[18] !== t8) {
    t9 = <StatsGrid items={statsData} styles={t8} />;
    $[17] = statsData;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t5 || $[21] !== t9) {
    t10 = <div>{t5}{t9}</div>;
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
function getHighlightStats(positionGroup: "GK" | "DEF" | "MID" | "FWD", aggregated: {
  appearances: number;
  minutes: number;
  goals: number;
  assists: number;
  cleansheets: number;
  saves: number;
  conceded: number;
  shots: number;
  shotsOnTarget: number;
}, labels: ReturnType<typeof useLabels>["playerPage"]["seasonStats"]) {
  switch (positionGroup) {
    case "GK":
      return [{
        id: "appearances",
        label: labels.appearances,
        value: aggregated.appearances
      }, {
        id: "minutes",
        label: labels.minutesPlayed,
        value: aggregated.minutes
      }, {
        id: "cleansheets",
        label: labels.cleanSheets,
        value: aggregated.cleansheets
      }, {
        id: "saves",
        label: labels.saves,
        value: aggregated.saves
      }, {
        id: "conceded",
        label: labels.goalsConceded,
        value: aggregated.conceded
      }];
    case "DEF":
      return [{
        id: "appearances",
        label: labels.appearances,
        value: aggregated.appearances
      }, {
        id: "minutes",
        label: labels.minutesPlayed,
        value: aggregated.minutes
      }, {
        id: "cleansheets",
        label: labels.cleanSheets,
        value: aggregated.cleansheets
      }, {
        id: "goals",
        label: labels.goals,
        value: aggregated.goals
      }, {
        id: "assists",
        label: labels.assists,
        value: aggregated.assists
      }];
    case "MID":
      return [{
        id: "appearances",
        label: labels.appearances,
        value: aggregated.appearances
      }, {
        id: "goals",
        label: labels.goals,
        value: aggregated.goals
      }, {
        id: "assists",
        label: labels.assists,
        value: aggregated.assists
      }, {
        id: "minutes",
        label: labels.minutesPlayed,
        value: aggregated.minutes
      }];
    case "FWD":
      return [{
        id: "appearances",
        label: labels.appearances,
        value: aggregated.appearances
      }, {
        id: "goals",
        label: labels.goals,
        value: aggregated.goals
      }, {
        id: "assists",
        label: labels.assists,
        value: aggregated.assists
      }, {
        id: "shots",
        label: labels.shots,
        value: aggregated.shots
      }, {
        id: "minutes",
        label: labels.minutesPlayed,
        value: aggregated.minutes
      }];
  }
}
function _temp(acc, item) {
  const s = item.stats;
  if (!s) {
    return acc;
  }
  return {
    appearances: acc.appearances + (s.appearances ?? 0),
    minutes: acc.minutes + (s.minutes ?? 0),
    goals: acc.goals + (s.goals ?? 0),
    assists: acc.assists + (s.assists ?? 0),
    cleansheets: acc.cleansheets + (s.cleansheets ?? 0),
    saves: acc.saves + (s.saves ?? 0),
    conceded: acc.conceded + (s.conceded ?? 0),
    shots: acc.shots + (s.shots ?? 0),
    shotsOnTarget: acc.shotsOnTarget + (s.shotsOnTarget ?? 0)
  };
}